import React from 'react';
import { Alert, AlertDescription, Icon } from '@chakra-ui/react';
import { AlertCircle, AlertTriangle, Bell, Smile } from '../../icons';
const iconMap = {
    error: AlertCircle,
    success: Smile,
    warning: AlertTriangle,
    info: Bell
};
export const FormFeedback = (props)=>{
    const { message , status , ...boxProps } = props;
    return /*#__PURE__*/ React.createElement(Alert, {
        bg: `support.${status}.background`,
        borderRadius: 8,
        p: 1,
        status: status,
        ...boxProps
    }, /*#__PURE__*/ React.createElement(AlertDescription, {
        color: `support.${status}.text`,
        display: "flex",
        textStyle: "m"
    }, /*#__PURE__*/ React.createElement(Icon, {
        as: iconMap[status],
        boxSize: 6,
        color: `support.${status}.icon`,
        mr: 1
    }), message));
};

//# sourceMappingURL=form-feedback.js.map